import { createSelector } from 'reselect';

export const selectVenuesSlice = state => state.venues;

export const selectVenues = createSelector(
  selectVenuesSlice,
  slice => slice.venues
);
export const venuesLoaded = createSelector(
  selectVenuesSlice,
  slice => slice.venuesLoaded
);
export const selectActiveVenue = createSelector(
  selectVenuesSlice,
  slice => slice.activeVenue
);
export const venueCreating = createSelector(
  selectVenuesSlice,
  slice => slice.isCreating
);
export const venuesMeta = createSelector(
  selectVenuesSlice,
  slice => slice.meta
);
export const venuesFilters = createSelector(
  selectVenuesSlice,
  slice => slice.filters
);
